import { render, staticRenderFns } from "./WithdrawMoneyDialog.vue?vue&type=template&id=7007cdc5&scoped=true&"
import script from "./WithdrawMoneyDialog.vue?vue&type=script&lang=ts&"
export * from "./WithdrawMoneyDialog.vue?vue&type=script&lang=ts&"
import style0 from "./WithdrawMoneyDialog.vue?vue&type=style&index=0&id=7007cdc5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7007cdc5",
  null
  
)

export default component.exports